import { FC } from 'react';
import { SlotInfo } from 'react-big-calendar';
import cx from 'clsx';
import styles from './styles.module.css';

type Props = {
  children: React.ReactNode;
  value: Date;
  resource?: any;
  campaignStartDate: Date;
  campaignEndDate: Date;
  onAddEvent: (slotInfo: SlotInfo) => void;
};

export const TimeSlotWrapper: FC<Props> = ({
  children,
  value,
  resource,
  campaignStartDate,
  campaignEndDate,
  onAddEvent,
}) => {
  const now = new Date();
  const slotTime = value.getTime();
  const campaignStart = campaignStartDate.getTime();
  const campaignEnd = campaignEndDate.getTime();

  const isInTimeRange = slotTime >= campaignStart && slotTime < campaignEnd;
  const isInPast = value < now;
  const isDisabled = !isInTimeRange || isInPast;

  const handleClick = () => {
    if (isDisabled) {
      return;
    }

    const slotInfo: SlotInfo = {
      start: value,
      end: new Date(value.getTime() + 30 * 60 * 1000),
      slots: [value],
      action: 'click',
      resourceId: resource,
    };

    onAddEvent(slotInfo);
  };

  return (
    <div
      onClick={handleClick}
      className={cx({
        [styles.timeSlot]: true,
        [styles.disabledTimeSlot]: isDisabled,
      })}
    >
      {children}
    </div>
  );
};
